<template>
	<!-- <v-container fluid> -->
		<!-- <v-row align-center> 
		
			<v-col cols="12" md="6" sm="6" >  
				
			</v-col>
			<v-col cols="12" md="6" sm="6">
				
			</v-col>
			<v-col cols="12" md="12" sm="12" xs="12">
				
			</v-col>
		</v-row> -->
		<grid-layout :layout.sync="layout"
			:margin  				= "[0,0]"
			:col-num 				= "120"
			:row-height 			= "20"
			:is-draggable 			= "grid_options.draggable"
			:is-resizable 			= "grid_options.resizable"
			:vertical-compact 		= "grid_options.vertical_compact"
			:prevent-collision 		= "grid_options.prevent_collision"
			:use-css-transforms 	= "true"
			:responsive 			= "grid_options.responsive"
			>
			<!-- :max-rows="12" -->
			<grid-item v-for="item in layout"
				:x="item.x"
				:y="item.y"
				:w="item.w"
				:h="item.h"
				:i="item.i"
				:minH="item.minH"
               	:minW="item.minW"
				:key="item.i"
				drag-allow-from=".vue-draggable-handle"
	        	drag-ignore-from=".no-drag"
	        	@resize="resizeEvent"
				>
				
					<!-- <recognized_face :search="search"></recognized_face> -->
					<component 
						:is 				= "item.component" 
						v-if 				= "item.component == 'recognized_face'"
						:layout 			= "item.h"
						:to_confidence  	= "confidence"
						:layout_id 			= "item.ID"
						@close_component 	= "del_draw($event)"
						
					></component>
				<!-- height -->
					<!-- :paginate='page' -->
					<!-- v-on:change_pagination="pagination=$event" -->
						

				<v-card outlined 
					v-if  = "item.component == 'main_face'" 
					style = "
						width 		 	 : 100%; 
						height 		 	 : 100%; 
						object-fit 	 : fill;   
						border-color : grey;"
				>
					<div class = "d-flex justify-space-between pa-0 secondary white--text"  >
              			<div class="justify-center  pa-0 col-md-10">
              				<!-- col-md-11 col-sm-10 cols-xs-11 -->
							<v-card-title 
								v-text="$ml.get('video_feed')" 
								class="justify-center pa-1 caption secondary vue-draggable-handle">
							</v-card-title>
						</div>
						<div class="pa-0" >
							<!-- col-md-1 col-sm-1 cols-1 col-xs-1  -->
							<v-menu offset-y>
					      <template 
					      	v-slot:activator = "{ on }"
					      >
					        <v-btn 
					        	dark 
					        	small 
					        	color 	= "primary"
					        	v-on 		= "on" 
					        	v-show 	= "show.edit_main"
					        >
					          <v-icon small>mdi-pencil</v-icon>
					        </v-btn>
					      </template>
					      <v-list dense>
					      	<v-dialog v-model="dialog" width="400">
					      		<template v-slot:activator="{ on }">
					      			
							        <v-list-item link small v-on="on"
							        	
							        >
							          <v-list-item-title > <v-icon small>mdi-playlist-edit</v-icon>	</v-list-item-title>
							        </v-list-item>
					      		</template>
					      		<v-card outlined >
					      			<v-card-title v-text="$ml.get('options')" class="justify-center body-1 secondary pa-1"></v-card-title>
					      			
					      			<v-divider></v-divider>
					      			<v-card-text>
					      				<v-text-field 
					      					outlined 
					      					dense 
					      					type="number" 
					      					v-model="id" 
					      					hide-details
					      					:label="$ml.get('id')"
					      					class="py-2"
					      				></v-text-field>
					      				<v-text-field 
					      					outlined 
					      					dense 
					      					type="text" 
					      					v-model="host"
					      					hide-details 
					      					class="pb-2"
					      					:label="$ml.get('device')"
					      					placeholder="UUID "
					      				></v-text-field>
					      				<v-text-field 
					      					outlined 
					      					dense 
					      					type="text" 
					      					v-model="name_device"
					      					hide-details 
					      					:label="$ml.get('name')"
					      				></v-text-field>
					      			</v-card-text>
					      			<v-divider></v-divider>
					      			<v-card-actions>
					      				<v-spacer></v-spacer>
					      				<v-btn 
					      					small color="success" 
					      					v-text="$ml.get('register')" 
					      					@click="add_host"
					      				></v-btn>
					      				<!-- <v-btn small color="primary" v-text="$ml.get('save')" @click=""></v-btn> -->
					      				<v-btn small color="error" v-text="$ml.get('close')" @click="dialog=false"></v-btn>
					      			</v-card-actions>
					      		</v-card>
					      	</v-dialog>
					      	<v-dialog v-model="dialog1" width="700">
					      		<template v-slot:activator="{ on }">
					      			<v-list-item link small v-on="on">
					      				<v-list-item-title >
					      					<v-icon small> mdi-view-list </v-icon>
					      				</v-list-item-title>
					      			</v-list-item>
					      		</template>
					      		<v-card outlined>
					      			<v-card-title v-text="$ml.get('host_list')" class="justify-center pa-1 body-1 secondary"></v-card-title>
					      			<v-divider></v-divider>
					      			<v-card-text>
					      				<v-simple-table height="400px" dense>
					      					<template v-slot:default>
					      						<thead>
					      							<tr>
					      								<th class="text-left">{{ $ml.get('id') }}</th>
					      								<th class="text-left">{{ $ml.get('device') }}</th>
					      								<th class="text-left">{{ $ml.get('uuid') }} </th>
					      								<th>{{$ml.get('actions')}}</th>
					      							</tr>
					      						</thead>
					      						<tbody>
					      							<tr v-for="(item, index) in list" :key="index">
					      								<td>{{ item.id }}</td>
					      								<td>{{ item.name }} </td>
					      								<td>{{ item.deviceId }}</td>
					      								<td>

					      									<v-btn x-small
					      										:color="item.selected ? 'primary' : 'secondary'"
					      										@click="sel(item)"
					      									>
					      										<span>
					      											{{ $ml.get('active') }}
					      										</span>
					      									</v-btn>
					      									<!-- <v-icon
														        small
														        color="primary"
														        class="mr-2"
														        @click="edit(item)"
														      >
														        mdi-pencil
														      </v-icon>
														      <v-icon
														        small
														        color="error"
														        @click="del(item)"
														      >
														        mdi-delete
														      </v-icon> 
														    </template>-->
					      								</td>
					      							</tr>
					      						</tbody>
					      					</template>
					      				</v-simple-table>
					      			</v-card-text>
					      			<v-divider></v-divider>
					      			<v-card-actions>
					      				<v-spacer></v-spacer>
					      				<v-btn x-small color="error" v-text="$ml.get('close')" @click="dialog1=false"></v-btn>
					      			</v-card-actions>
					      		</v-card>
					      	</v-dialog>
					      	<v-dialog v-model="dialog2" width="300">
					      		<template v-slot:activator="{ on }">
					      			<v-list-item link small v-on="on">
					      				<v-list-item-title >
					      					<v-icon small> mdi-file-percent </v-icon>
					      				</v-list-item-title>
					      			</v-list-item>
					      		</template>
					      		<v-card outlined>
					      			<v-card-title v-text="$ml.get('confidence')" class="justify-center pa-1 body-1 secondary"></v-card-title>
					      			<v-divider></v-divider>
					      			<v-card-text class="pa-2">
					      				<v-text-field
					      					outlined
					      					v-model.number="confidence"
					      					:label="$ml.get('enter_value')"
					      					type="number"
					      					hide-details
					      					dense
					      				></v-text-field>
					      			</v-card-text>
					      			<v-divider></v-divider>
					      			<v-card-actions>
					      				<v-spacer></v-spacer>
					      				<v-btn x-small
					      					color="primary"
					      					v-text="$ml.get('save')"
					      					@click="save_confidence"
					      				></v-btn>
					      				<v-btn x-small
					      					color="error"
					      					v-text="$ml.get('close')"
					      					@click="dialog2=false"
					      				></v-btn>
					      			</v-card-actions>
					      		</v-card>
					      	</v-dialog>
					      </v-list>
					    </v-menu>
						</div>
					</div>
					<v-divider></v-divider>
					<!-- <v-card-text class="no-drag pa-0" > -->
						
						<!-- :height_main="height_to_main" -->
					<!-- <main_face 
						:info_selected="info_sel"
					></main_face> -->
					<cam
						style="height: 90%"
						:id_stream 	= " info_sel ? info_sel.deviceId : null"
						:hostname 	= " info_sel ? info_sel.name : null"
						:layout_id 	= " item.ID"
						:show_bar="true"
					></cam>
					<!-- <component :is="item.component" v-if="item.component=='main_face'"></component> -->
					<!-- </v-card-text> -->
				
				</v-card>

				
						<!-- <select_face></select_face> -->
				<component 
					:is 					= "item.component" 
					v-if= "item.component  == 'select_face'"
					:layout 				= "item.h"
					:layout_id 				= "item.ID"
				></component>
					<!-- :paginate_select 		= 'page_select' -->
					<!-- v-on:change_pagination 	= "pagination_select = $event" -->
						
			</grid-item>
		</grid-layout>
		<!-- <notics_inf
			:info="inform"
			v-if="inform" 
			@confirm_message="del($event)"
			@close_snack_dialog="inform=$event"
		/> -->

		
	<!-- </v-container> -->
</template>
<style scoped>
  .vue-grid-item>>>.vue-resizable-handle{ /* /deep/ */
    background-color: #9c8888; /* white #047dc3*/
   /* filter: grayscale(100%);*/ 
    /*filter: invert(100%);*/
    opacity:0.5;
    width:10px;
    height: 10px;
    /*filter: brightness(0.5);*/
   filter: hue-rotate(180deg); 
    /*filter: opacity(50%); */
  }
</style>

<script>
import main_face 					from '@/components/face/main_face.vue'
import select_face 		 		from '@/components/face/detected_face.vue'
import recognized_face 		from '@/components/face/recognized_face.vue'
import show_face 					from '@/components/face/show_face.vue'
import VueGridLayout 			from 'vue-grid-layout'
import EventBus 					from '@/event-bus'
import cam 								from '@/components/cam_test.vue'
// import notics_inf from '@/components/notics_inf.vue';

	export default{
		name 				: 'face', //Alice_
		components 	: { 
			main_face, 
			select_face , 
			recognized_face, 
			show_face , 
			GridLayout: VueGridLayout.GridLayout,
			GridItem: VueGridLayout.GridItem, 
			cam,
			// notics_inf 
		},
		data 			: () =>({
			layout 				: [],
			grid_options 	: {
			 	draggable 				: true,
			 	resizable 				: true,
			 	vertical_compact 	: true,
			 	prevent_collision : true,
			 	responsive 				: false,
			},
			dialog 			: false, // modal edit
			dialog1 		: false, //modal list
			host 				: '',
			id 					: '',
			list 				: [],
			sel_search 	:'',
			inform 		 	: null,
			info_sel 		: null,
			dialog2 		: false,
			confidence 	: 0.1,
			name_device : '',
			show 				: {
				edit_main : true,

			},

		}), //data
		watch:{
			/*layout: function(v){
				// console.log('changeds', this.layout )
				let layout_t 	= this.layout_t, 
					layout 		= this.layout;
				if (layout) {
					let layout1 = JSON.stringify(layout)
	        		localStorage.setItem('changed_profile_face',layout1);
					// layout_t=v;
				}
			}, //layout*/
			
		}, //watch

		created(){
			
			if (!this.$store.getters["auth/permission"]("face", "can_edit", "face")) {
				this.show.edit_main = false;
			}
		}, //created

		methods:{
			// send(){
			// 	this.search_l=this.search;
			// }

			draw(){
				let layout 		= [], 
					recognized 	= 'recognized_face', 
					main 		= 'main_face', 
					select 		= 'select_face';

				let layout_t 	= [];
				
				let gw = 120 / 4;//this.$setting_grid.number_grids;
				let gh = (this.$vuetify.breakpoint.height * 0.02137);
				     
				console.log('height ********** ', gh, this.$vuetify.breakpoint.height, window.innerHeight, window.innerHeight * 0.02137)


				layout_t = {
					x 			: 0,
					y 			: 0,
					w 			: 60,
					h 			: gh,//15,
					i 			: 0,
					minW 		: 45, 
					minH 		: 15,
					component 	: recognized,
					ID 			:  0 + recognized,
				}
				layout.push(layout_t);

				layout_t = {
					x 			: 60,
					y 			: 0,
					w 			: 60,
					h 			: gh,//15,
					i 			: 1,
					minW 		: 45,
					minH 		: 15,
					component 	: main,
					ID 			: 1 + main,
				}
				layout.push(layout_t);
				layout_t = {
					x 			: 0,
					y 			: 15,
					w 			: 120,
					h 			: gh,//13,
					i 			: 2,
					minW 		: 45,
					minH 		: 13,
					component 	: select,
					ID 			: 2 + select,
				}

				layout.push(layout_t);

				this.layout = layout;
			}, // draw

			

			add_host(){
				let Id 	 = this.id, 
					Host = this.host, 
					name_dev 	= this.name_device,
					selected 	= false;
				this.list.push({ id:Id, deviceId: Host, name: name_dev,selected})
				this.save_local();
				this.dialog = false;
				EventBus.$emit('notifications_modal', {
					type: 'saved',					
				})

			}, // add host

			save_local(){
				let list_save=JSON.stringify(this.list);
				localStorage.setItem('host_face_list',list_save);
				let info=this.$ml.get('save');						
				// this.inform={info, color:'success', snack: true, type: false};
				EventBus.$emit('notifications_modal', {
					type: 'saved',					
				})
			}, // save storage

			save_confidence(){
				let Confidence=JSON.stringify(this.confidence);
				localStorage.setItem('confidence_face', Confidence);
				let info=this.$ml.get('save');						
				// this.inform={info, color:'success', snack: true, type: false};
				EventBus.$emit('notifications_modal', {
					type: 'saved',					
				})
				this.dialog2=false;
			},

			sel(item){
				let list_render=this.list;
				for (let i = 0; i < list_render.length; i++) {
					if (list_render[i].id== item.id) {
						list_render[i].selected=true;
					}else{
						list_render[i].selected=false;
					}
				}
				this.list=list_render;
				this.save_local();
				this.info_sel=item;
				this.dialog1=false;
			},
			resizeEvent: function(i, newH, newW, newHPx, newWPx){
            // var msg = "RESIZE i=" + i + ", H=" + newH + ", W=" + newW + ", H(px)=" + newHPx + ", W(px)=" + newWPx;
            // this.eventLog.push(msg);
            // console.log(msg);
            	// this.onResize();
        	}, //resizeEvent

        	del_draw(val){
        		let vm 			= this;
        		let search 		= val;

        		const finded 	= vm.layout.some( function(arr_del, idx_del){
        			if (search == arr_del.ID) {
        				vm.layout.splice(idx_del, 1);
        			}
        		})
        			
        	}, // del draw

		}, // methods

		mounted(){
			//this.height=400;
			let vm = this;
			
			this.draw();

			EventBus.$on('profile_face', (actions) =>{
				// console.log(actions, 'profile')
				this.layout 	= actions;
				// this.check_selects(this.layout);
			});
			EventBus.$on('save_profile_face', () =>{ 
				const layout 	= JSON.stringify(this.layout)
	        	localStorage.setItem('save_profile_face',layout);
			})

		 	if (localStorage.getItem('changed_profile_face')) {		
		    	this.layout 	= JSON.parse(localStorage.getItem('changed_profile_face')); 		    
		    	// this.check_selects(this.layout);
		    }

		    // drawable options
			EventBus.$on('drawable_face', (actions)=>{ 
			    this[actions.option] 	= actions.active;
			});

			if (localStorage.getItem('host_face_list')) {
				let list_render 	= JSON.parse(localStorage.getItem('host_face_list'))
				let vm 				= this;

				list_render.some( function(val, index, arr){
					if (val.selected) {
						vm.info_sel = val;
					}

				})

				this.list = list_render;
				if (localStorage.getItem('list_devices')) {
					let list_temp = JSON.parse(localStorage.getItem('list_devices'));
					if (list_temp && list_temp.length > 0) {

						const find = list_render.some( function(val1, index1, arr1){
							if (val1 && val1.deviceId && val1.deviceId == list_temp[0].deviceId) {
								return true
							}

						})
						if (!find) {
							this.list = this.list.concat(list_temp);
						}
					}
				} 
			}// get host face list
			else {
				if (localStorage.getItem('list_devices')) {
					let list_temp = JSON.parse(localStorage.getItem('list_devices'));
					this.list 	  = list_temp;
				}

			}
			

			if (localStorage.getItem('confidence_face')) {
				this.confidence=JSON.parse(localStorage.getItem('confidence_face'));
			}
		}, // mounted
	};
</script>